import { AuthComponent } from './auth.component';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthForgetComponent } from './auth-forget/auth-forget.component';
import { AuthResetComponent } from './auth-reset/auth-reset.component';
import { AccessDeniedComponent } from '../pages/access-denied/access-denied.component';
import { MfaSetupComponent } from './mfa-setup/mfa-setup.component';

const routes: Routes = [{
  path: '',
  component: AuthComponent,
  children: [
    {
      path: 'login',
      component: AuthLoginComponent,
    },
    {
      path: 'logout',
      component: AuthLoginComponent,
    },
    {
      path: 'forget',
      component: AuthForgetComponent,
    },
    {
      path: 'reset',
      component: AuthResetComponent,
    },
    {
      path: 'mfa-setup',
      component: MfaSetupComponent,
    },
    {
      path: '',
      redirectTo: 'login',
      pathMatch: 'full',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }

export const routedComponents = [
  AuthComponent,
  AuthLoginComponent,
  AuthForgetComponent,
  MfaSetupComponent
];
